import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/product/chenggui',
    name: 'chenggui',
    component: () => import('../views/product/ChengGui.vue')
  },
  {
    path: '/product/railway',
    name: 'railway',
    component: () => import('../views/product/RailWay.vue')
  },
  {
    path: '/product/lowaltitude',
    name: 'lowaltitude',
    component: () => import('../views/product/LowAltitude.vue')
  },
  {
    path: '/product/emergencyresponse',
    name: 'emergencyresponse',
    component: () => import('../views/product/EmergencyResponse.vue')
  },

  {
    path: '/service/Train',
    name: 'Train',
    component: () => import('../views/service/TrainPage.vue')
  },
  {
    path: '/service/Competition',
    name: 'Competition',
    component: () => import('../views/service/CompetitionPage.vue')
  },

  {
    path: '/join/joinUs',
    name: 'joinUs',
    component: () => import('../views/about/AboutUs.vue')
  },

  {
    path: '/case/CasePage',
    name: 'case',
    component: () => import('../views/case/CasePage.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
